export default function scrollToToP() {
    const scroller = document.createElement("div");
    scroller.classList.add("scrollToTop", "hexary__bg", "tertiary__text");
    scroller.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21.317 26.757">
      <g id="Group_199" data-name="Group 199" transform="translate(-1281.783 894.257) rotate(-90)">
        <path id="Path_20" data-name="Path 20" d="M0,0,9.951,9.952,19.9,0" transform="translate(882.891 1302.394) rotate(-90)" fill="none" stroke="currentColor" stroke-width="2"/>
        <line id="Line_1" data-name="Line 1" x1="25" transform="translate(867.5 1292.487)" fill="none" stroke="currentColor" stroke-width="2"/>
      </g></svg>`;
    scroller.addEventListener("click", function () {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    });
    document.body.appendChild(scroller);
}
